import React, { useEffect, useRef, useState } from "react";
import { range } from "../hooks/math-lerps";
import { useAnimationFrame } from "../hooks/useAnimationFrame";
import { lines } from "./lines";
import useMediaQuery from "../hooks/useMediaQuery";

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined";

export const LineSection = ({ id }) => {
  const [length, setLength] = useState(0);
  // How far down the page does the line start
  const YOFFSET = isBrowser ? window.innerHeight / 2 : null;

  const mobile = useMediaQuery("(max-width: 980px)");
  const svg = useRef(null);

  useEffect(() => {
    if (svg.current) {
      //Path is inside a group <g>
      const path = svg.current.children[0].children[0];
      path.setAttribute("d", mobile ? lines[id].mobile_path : lines[id].path);
      setLength(path.getTotalLength()); // dashOffset goes from full length to zero - over the length of the div (100vh)
    }
  }, [id, mobile]);

  useAnimationFrame(() => {
    //Animation Loop goes here
    if (svg.current) {
      const { height, top } = svg.current.getBoundingClientRect();
      //Path is inside a group <g>

      const path = svg.current.children[0].children[0];

      // const length = path?.getTotalLength(); // dashOffset goes from full length to zero - over the length of the div (100vh)
      const offset = range(
        0, //start when the top of the div hits 0
        -height, //top-value is 0 ---> negative height, so height must be negative
        length, //length of the dasharray
        0,
        top - YOFFSET
      ); // convert dashOffset to the range 0 --> length, less the YOFFSET

      // Offset the start so that scrollY goes from 0 to adding the YOFFSET, but wait interpolate upto -120px of scrollY
      const offsetStart = range(
        0,
        -height,
        length, //mobile is off by ~200??
        0,
        top - range(0, 120, 0, YOFFSET, -top)
      );

      if (id === 0) {
        path.setAttribute("stroke-dashoffset", offsetStart);
      } else {
        path.setAttribute("stroke-dashoffset", offset);
      }
    }
  });
  return (
    <div className="line-art-container">
      <svg
        ref={svg}
        width="100%"
        height="100%"
        viewBox={mobile ? "0 0 393 852" : "0 0 1708 1117"}
        fill="none"
        preserveAspectRatio="none"
        vectorEffect="non-scaling-stroke"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clipper)">
          <path
            className="path"
            strokeDashoffset={length} //This gets replaced by a real number immediately
            strokeDasharray={length} //This gets replaced by a real number immediately
            d="M0 0"
          />
        </g>
        <defs>
          <clipPath id="clipper">
            <rect
              width={mobile ? "393" : "1708"}
              height={mobile ? "852" : "1117"}
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
